import React, { HTMLAttributes } from 'react';
import {
  WysiwygField,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';

import './style.scss';
import { ParagraphUSPSubparagraph as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphUSPSubparagraphProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphUSPSubparagraph: React.FC<ParagraphUSPSubparagraphProps> = ({
  entity,
}) => {
  const paragraph = entity.toJS();
  const uuid = paragraph.uuid[0].value;
  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.processed;
  const image = paragraph.field_media_item[0]?.styles?.original;

  return (
    <div id={uuid} className="ParagraphUSPSubparagraph">
      {image && (
        <div className="ParagraphUSPSubparagraph__image">
          <Image src={image} />
        </div>
      )}
      <h3 className="ParagraphUSPSubparagraph__title">{title}</h3>
      {body && <WysiwygField html={body} />}
    </div>
  );
};

export default ParagraphUSPSubparagraph;
